module.exports = __webpack_public_path__ + "static/media/step2_br.738b735f.png";